import "./style.css"
import React  from "react";
import {Spin} from 'antd';
interface Props {
    styles?: any
    size?: any
}

const LoadingComponent: React.FC<Props> = (props) => {
    return <div className="loadingComponent" style={Object.assign(props.styles || {}, {textAlign : "center"})}>
        <Spin size={props.size || "small"} />
    </div>
}

export default LoadingComponent
